const initialState = {
    //NewsMain
    news_main: [],
    //AnnouncementInter
    newsInter_application: [],
    newsInter_writing: [],
    newsInter_clearing: [],
    newsInter_qualified: [],
    newsInter_confirm: [],
    //AnnouncementCon
    newsCon_application: [],
    newsCon_writing: [],
    newsCon_clearing: [],
    newsCon_qualified: [],
    newsCon_confirm: [],
    //AnnouncementPremium
    newsPremium_application: [],
    newsPremium_writing: [],
    newsPremium_clearing: [],
    newsPremium_qualified: [],
    newsPremium_confirm: [],
    //AnnouncementTCAS
    newsTCAS_application: [],
    newsTCAS_writing: [],
    newsTCAS_clearing: [],
    newsTCAS_qualified: [],
    newsTCAS_confirm: [],
};
import { getField, updateField } from 'vuex-map-fields';
import AnnouncementProvider from '../services/announcement.provider'
const announcementService = new AnnouncementProvider()

export const announcement = {
    namespaced: true,
    state: initialState,
    actions: {
        async getNewsMains({ commit }) {
            const data = await announcementService.getNewsMains();
            commit('setNewsMains', data);
        },
        //AnnouncementInter
        async getNewsInters_application({ commit }) {
            const data = await announcementService.getNewsInters_application();
            commit('setNewsInters_application', data);
        },
        async getNewsInters_writing({ commit }) {
            const data = await announcementService.getNewsInters_writing();
            commit('setNewsInters_writing', data);
        },
        async getNewsInters_interview({ commit }) {
            const data = await announcementService.getNewsInters_interview();
            commit('setNewsInters_interview', data);
        },
        async getNewsInters_clearing({ commit }) {
            const data = await announcementService.getNewsInters_clearing();
            commit('setNewsInters_clearing', data);
        },
        async getNewsInters_qualified({ commit }) {
            const data = await announcementService.getNewsInters_qualified();
            commit('setNewsInters_qualified', data);
        },
        async getNewsInters_confirm({ commit }) {
            const data = await announcementService.getNewsInters_confirm();
            commit('setNewsInters_confirm', data);
        },
        //AnnouncementCon
        async getNewsCons_application({ commit }) {
            const data = await announcementService.getNewsCons_application();
            commit('setNewsCons_application', data);
        },
        async getNewsCons_writing({ commit }) {
            const data = await announcementService.getNewsCons_writing();
            commit('setNewsCons_writing', data);
        },
        async getNewsCons_interview({ commit }) {
            const data = await announcementService.getNewsCons_interview();
            commit('setNewsCons_interview', data);
        },
        async getNewsCons_clearing({ commit }) {
            const data = await announcementService.getNewsCons_clearing();
            commit('setNewsCons_clearing', data);
        },
        async getNewsCons_qualified({ commit }) {
            const data = await announcementService.getNewsCons_qualified();
            commit('setNewsCons_qualified', data);
        },
        async getNewsCons_confirm({ commit }) {
            const data = await announcementService.getNewsCons_confirm();
            commit('setNewsCons_confirm', data);
        },
        //AnnouncementPremium
        async getNewsPremiums_application({ commit }) {
            const data = await announcementService.getNewsPremiums_application();
            commit('setNewsPremiums_application', data);
        },
        async getNewsPremiums_writing({ commit }) {
            const data = await announcementService.getNewsPremiums_writing();
            commit('setNewsPremiums_writing', data);
        },
        async getNewsPremiums_interview({ commit }) {
            const data = await announcementService.getNewsPremiums_interview();
            commit('setNewsPremiums_interview', data);
        },
        async getNewsPremiums_clearing({ commit }) {
            const data = await announcementService.getNewsPremiums_clearing();
            commit('setNewsPremiums_clearing', data);
        },
        async getNewsPremiumns_qualified({ commit }) {
            const data = await announcementService.getNewsPremiums_qualified();
            commit('setNewsPremiums_qualified', data);
        },
        async getNewsPremiums_confirm({ commit }) {
            const data = await announcementService.getNewsPremiums_confirm();
            commit('setNewsPremiums_confirm', data);
        },
        //AnnouncementTCAS
        async getNewsTCASs_application({ commit }) {
            const data = await announcementService.getNewsTCASs_application();
            commit('setNewsTCASs_application', data);
        },
        async getNewsTCASs_writing({ commit }) {
            const data = await announcementService.getNewsTCASs_writing();
            commit('setNewsTCASs_writing', data);
        },
        async getNewsTCASs_interview({ commit }) {
            const data = await announcementService.getNewsTCASs_interview();
            commit('setNewsTCASs_interview', data);
        },
        async getNewsTCASs_clearing({ commit }) {
            const data = await announcementService.getNewsTCASs_clearing();
            commit('setNewsTCASs_clearing', data);
        },
        async getNewsTCASns_qualified({ commit }) {
            const data = await announcementService.getNewsTCASs_qualified();
            commit('setNewsTCASs_qualified', data);
        },
        async getNewsTCASs_confirm({ commit }) {
            const data = await announcementService.getNewsTCASs_confirm();
            commit('setNewsTCASs_confirm', data);
        },
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        setNewsMains(state, data) { state.news_main = data },
        //AnnouncementInter
        setNewsInters_application(state, data) { state.newsInter_application = data },
        setNewsInters_writing(state, data) { state.newsInter_writing = data },
        setNewsInters_interview(state, data) { state.newsInter_interview = data },
        setNewsInters_clearing(state, data) { state.newsInter_clearing = data },
        setNewsInters_qualified(state, data) { state.newsInter_qualified = data },
        setNewsInters_confirm(state, data) { state.newsInter_confirm = data },
        //AnnouncementCon
        setNewsCons_application(state, data) { state.newsCon_application = data },
        setNewsCons_writing(state, data) { state.newsCon_writing = data },
        setNewsCons_interview(state, data) { state.newsCon_interview = data },
        setNewsCons_clearing(state, data) { state.newsCon_clearing = data },
        setNewsCons_qualified(state, data) { state.newsCon_qualified = data },
        setNewsCons_confirm(state, data) { state.newsCon_confirm = data },
        //AnnouncementPremium
        setNewsPremiums_application(state, data) { state.newsPremium_application = data },
        setNewsPremiums_writing(state, data) { state.newsPremium_writing = data },
        setNewsPremiums_interview(state, data) { state.newsPremium_interview = data },
        setNewsPremiums_clearing(state, data) { state.newsPremium_clearing = data },
        setNewsPremiums_qualified(state, data) { state.newsPremium_qualified = data },
        setNewsPremiums_confirm(state, data) { state.newsPremium_confirm = data },
        //AnnouncementTCAS
        setNewsTCASs_application(state, data) { state.newsTCAS_application = data },
        setNewsTCASs_writing(state, data) { state.newsTCAS_writing = data },
        setNewsTCASs_interview(state, data) { state.newsTCAS_interview = data },
        setNewsTCASs_clearing(state, data) { state.newsTCAS_clearing = data },
        setNewsTCASs_qualified(state, data) { state.newsTCAS_qualified = data },
        setNewsTCASs_confirm(state, data) { state.newsTCAS_confirm = data },
    },
};